var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterCard = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@wheelroom/core");

var card_navigation_1 = require("../../navigation/variants/card-navigation");

exports.FooterCard = function (props) {
  if (props.hideCard === true) {
    return null;
  }

  var ContainerType = props.containerStyle === 'container' ? core_1.Container : core_1.Fluid;
  return react_1.default.createElement(core_1.Wrapper, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.wrapper
    })
  }, react_1.default.createElement(ContainerType, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.container
    })
  }, react_1.default.createElement(card_navigation_1.CardNavigation, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.cardNavigation
    }),
    maxSegments: 10,
    navigation: props.navigation,
    hideCard: props.hideCard
  })));
};